import { render, staticRenderFns } from "./WorkerGroupEdit.vue?vue&type=template&id=3bdc6bc5&"
import script from "./WorkerGroupEdit.vue?vue&type=script&lang=js&"
export * from "./WorkerGroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./WorkerGroupEdit.vue?vue&type=style&index=0&id=3bdc6bc5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports